import React, { useEffect } from "react";
import useReactRouter from "use-react-router";
// import * as _ from "lodash";
import { useSubscription } from "@apollo/client";

// constants
import MultiStepForm from "./MultiStepForm";
import logoLogin from "../../../image/logo_main.png";
import { SUBSCRIPTION_COMPLETED_PAYMENT_V2 } from "../../../graphql/order/mutation";
// import { GET_ORDER_GROUPS_SHOP_SETTING } from "../../../graphql/order/query";
// import { errorSwal } from "../../../helpers/sweetalert";
// import LoadingAbsolute from "../../../components/loading/LoadingAbsolute";
// import ConfirmPaymentAuto from "./confirm_payment_auto";
// import { FaFileInvoice } from "react-icons/fa";


function OrderConfirm() {
  const { match } = useReactRouter();
  // const [orderShopSetting, setOrderShopSetting] = useState(null);
  // const [customerInfo, setCustomerInfo] = useState(false);

  // const [getOrderShopSetting, {loading: orderShopSettingLoading }] =
  //   useLazyQuery(GET_ORDER_GROUPS_SHOP_SETTING, {
  //     onCompleted: (data) => {
  //       if (data.orderGroupShopSetting?.status || data.orderGroupShopSetting?.dataOne) {
  //         setOrderShopSetting(data.orderGroupShopSetting.dataOne);
  //       } else {
  //         console.error("Create error:", data.orderGroupShopSetting?.msg || "Failed to create order group");
  //         return errorSwal(data.orderGroupShopSetting?.msg || "ເກີດຂໍ້ຜິດພາດໃນການສ້າງອໍເດີ້");
  //       }
  //     },
  //     onError: (error) => {
  //       console.error("Create error:", error.message);
  //       return errorSwal(error.message || "ເກີດຂໍ້ຜິດພາດ ກະລຸນາລອງໃໜ່ອີກຄັ້ງ");
  //     }
  //   });

  const { data: onCompletedPaymentV2 } = useSubscription(SUBSCRIPTION_COMPLETED_PAYMENT_V2, {
    variables: {
      orderId: match?.params?.data,
    },
  });

  // subscribe completed payment
  useEffect(() => {
    if (onCompletedPaymentV2) {
      if (onCompletedPaymentV2?.onCompletedPaymentV2?.id === match?.params?.data) {
        // const orderGroup = onCompletedPaymentV2?.onCompletedPaymentV2;
        // console.log("onCompletedPaymentV2 3", orderGroup);
        // if (orderShopSetting?.isPaymentGateway && (!orderGroup?.phone || !orderGroup?.addressCf || (!orderGroup?.customerName && !orderGroup?.cfName))) {
          window.location.reload()
      }
    }
  }, [onCompletedPaymentV2]);

  // useEffect(() => {
  //   if (!match?.params?.data) return;
  //   getOrderShopSetting({
  //     variables: {
  //       where: {
  //         id: match?.params?.data,
  //       },
  //     },
  //   });
  // }, [match?.params?.data]);


  // if (orderShopSettingLoading) return <LoadingAbsolute />
  return (
    <div style={{ position: 'relative', background: "#f1f1f1" }}>

      <div style={{ padding: 10, borderBottom: '1px solid #f2f2f2', background:'#fff' }} className="d-flex gap-2 justify-content-start align-items-center">
        <div
          style={{
            width: 40,
            height: 40,
            overflow: "hidden",
            display: "flex",
            gap: 2,
            border: '1px solid #dedede', borderRadius: 10
          }}
        >
          <img
            style={{ width: "100%", height: "100%" }}
            src={logoLogin}
          />
        </div>
        <h5 style={{ fontWeight: 'bold', fontSize: 23 }}>
          Super CF
        </h5>
      </div>

      <div style={{ padding: 5 }}>
        <MultiStepForm />
      </div>

      {/* <div style={{ padding: 5, marginBottom: "2em" }}>
        {orderShopSetting ? (<>
          {orderShopSetting?.isPaymentGateway ? <ConfirmPaymentAuto customerInfo={customerInfo} setCustomerInfo={setCustomerInfo} /> : <MultiStepForm />}
        </> )
        : (<MultiStepForm />)}
      </div> */}

      {/* <div className="tell-me-button">
          <p>bill</p>
          <button className="btn-digital-bill">
            <FaFileInvoice />
          </button>
          <p>history</p>
      </div> */}
    </div>
  );
}

export default OrderConfirm;
